import { NavigationGuardNext, Route } from 'vue-router'
import { store } from '../store'

/**
 * TokenGuard
 * 
 * Checks if a 'use-once' token is set in the route. Attempts to retrieve
 * a temporary user with the token.
**/
export default async (to: Route, from, next: NavigationGuardNext) => {
    //  Create a 'pass' function
    const pass = (why: string): void => {
        store.getters.appDebug && console.log(`GUARD: LinkAccountGuard - pass ${why}`)
        return next()
    }

    //  Create a 'fail' function
    const fail = (why: string): void => {
        store.getters.appDebug && console.error(`GUARD: LinkAccountGuard - fail ${why}`)
        return next('/')
    }

    //  Check for the 'token' url query param
    const token = to.query.token || null

    //  If the token does NOT exist, route to signin
    if (!token) return fail('no token')

    //  Else, fetch the temporary user with the token
    const user = await store.dispatch('authUserTmpGet', token)

    //  If no user exists, guard fails
    if (!user) return fail('no user')

    //  Else guard passes
    return pass('Temp user loaded')
}
